"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanSelectionCommandToJSON = exports.PlanSelectionCommandFromJSONTyped = exports.PlanSelectionCommandFromJSON = void 0;
const runtime_1 = require("../runtime");
function PlanSelectionCommandFromJSON(json) {
    return PlanSelectionCommandFromJSONTyped(json, false);
}
exports.PlanSelectionCommandFromJSON = PlanSelectionCommandFromJSON;
function PlanSelectionCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'plan': json['plan'],
        'affiliate': !runtime_1.exists(json, 'affiliate') ? undefined : json['affiliate'],
    };
}
exports.PlanSelectionCommandFromJSONTyped = PlanSelectionCommandFromJSONTyped;
function PlanSelectionCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'plan': value.plan,
        'affiliate': value.affiliate,
    };
}
exports.PlanSelectionCommandToJSON = PlanSelectionCommandToJSON;
//# sourceMappingURL=PlanSelectionCommand.js.map